const doc = [({"da":({"js":({"admin":({"contacts":({"edit":({"student_council_content":({"student_council_information":"Elevrådsinformation"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;